import { useEffect, useRef } from 'react';

export function useMountEffect(callback: VoidFunction): void {
  const funcRef = useRef(callback);

  funcRef.current = callback;

  useEffect(() => {
    funcRef.current();
  }, []);
}
